export const BUDGETS_API_URLS = {
    EMPLOYEE:       "/employee",
    DISTRIBUTORS:   "/distributors",
    PRODUCTS:       "/products",
    BUDGETS:        "/budgets",
    PDF_BUDGETS:    "/pdf/budgets",
    SEND_BUDGET_PDF:"/send/pdf",
    CLIENTS:        "/clients",
    ENTRIES:        "/entries",
    LICENSE_TYPES:  "/licenses/list-types",
    LICENSES:       "/licenses/list-assigned",
    LICENSE_ASSIGN: "/licenses/assign",
    LICENSE_RENEW: "/licenses/renew",
    LICENSE_CANCEL: "/licenses/cancel",
    LICENSE_REACTIVATE: "/licenses/reactivate",
    LICENSE_ASSIGN_BULK: "/licenses/assign_bulk",

    DISTRIBUTOR_AVATAR: "/distributors/avatar",
    DISTRIBUTOR_DEVICES: "/distributors/devices",
    DISTRIBUTOR_LOCATIONS: "/distributors/locations",
    DISTRIBUTOR_ADMIN_LOCATIONS: "/distributors/admins/locations",
};